import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';
import ReactPlayer from 'react-player';
import Draggable from 'react-draggable';

import asyncComponent from '../hoc/asyncComponent/asyncComponent';
import TopNav from './TopNav';
import * as InstallationWizardAction from "../../actions/InstallationWizardAction";
import ErrorMsg from "../common/ErrorMsg";
import videoIcon from "../../public/assets/images/video_icon.png";
import ConfirmModal from '../common/ConfirmModal';
import loadingGIF from "../../public/assets/images/loading.gif";
import ZendeskSupport from "../common/Zendesk";


const WelcomeComponent = asyncComponent(() => {
    return import('./Welcome');
});

const AgencySetupComponent = asyncComponent(() => {
    return import('./AgencySetup');
});

const JobDescriptionComponent = asyncComponent(() => {
    return import('./JobDescription');
});

const AddUserComponent = asyncComponent(() => {
    return import('./AddUser');
});

const AgencyNumberComponent = asyncComponent(() => {
    return import('./AgencyNumber');
});

const DestinationComponent = asyncComponent(() => {
    return import('./Destination');
});

const HabitsComponent = asyncComponent(() => {
    return import('./Habits');
});

const KPIsComponent = asyncComponent(() => {
    return import('./KPIs');
});

const ImportRecordComponent = asyncComponent(() => {
    return import('./ImportRecord');
});

const ProducerPlanComponent = asyncComponent(() => {
    return import('./ProducerPlan');
});

const CompProfileComponent = asyncComponent(() => {
    return import('./CompProfile');
});

const FinalRollOutComponent = asyncComponent(() => {
    return import('./FinalRollOut');
});


class InstallationWizard extends Component {
    state = {
        isLoading: false,
        activeTab: 0,
        activeModuleObj: {},
        selectedVideo: {},
        showVideo: false,
        showConfirmModal: false,
        model : {
            msgTitle : '',
            msgBody : '',
            buttons : []
        },
        draggableDivPosition: window.screen.availWidth / 2 - 200
    }

    componentDidMount() {
        this.getIWDetails();
    }

    componentDidUpdate(prevProps) {
        if (this.props.agencyLocation !== prevProps.agencyLocation) {
            this.setState({activeTab: 0, activeModuleObj: {}});
            this.getIWDetails();
        }
    }

    getIWDetails = async () => {
        if (this.props.agencyLocation) {
            try {
                const result = await this.props.getIWModules(this.props.agencyLocation);
                if (result) {
                    let activeTab = 0;
                    let activeModuleObj = this.props.iwData.modules.length ? {...this.props.iwData.modules[0]} : {};
                    this.props.iwData.modules.map((module, index) => {
                        if(module.is_in_progress) {
                            activeTab = index;
                            activeModuleObj = {...module};
                        }
                    });
                    this.setState({activeTab, activeModuleObj}, () => this.getVideosList());
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    }

    getVideosList = async () => {
        const {activeModuleObj} = this.state;
        
        if (!isEmpty(activeModuleObj) && activeModuleObj.id) {
            this.setState({isLoading: true});
            try {
                const result = await this.props.getIWVideos(activeModuleObj.id);
                if (result) {
                    let videoList = this.props.iwData.videos.map(video => ({...video}));
                    let selectedVideo = {...videoList[0]}
                    for (let index in videoList) {
                        if (!videoList[index].seen) {
                            selectedVideo = {...videoList[index]};
                            break;
                        }
                    }
                    this.setState({selectedVideo});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isLoading: false});
        }        
    };

    startVideo = (video) => {
        this.setState({selectedVideo: video, showVideo: true});
    }

    closeVideo = () => {
        this.setState({showVideo: false});
    }

    nextModule = async () => {
        let curActiveTab = this.state.activeTab;
        let tabShouldBeActive = curActiveTab;
        let {modules} = this.props.iwData;
        let curActiveModuleObj = {...modules[curActiveTab]};
        let moduleShouldBeActive = {...curActiveModuleObj};
        let completedCount = 0;
        let noOfModule = modules.length;
        
        // Looking for next module which is in progress
        modules.map((moduleObj, index) => {
            if (moduleObj.is_completed) {
                completedCount += 1;
            }
            if (moduleObj.is_in_progress) {
                // tabShouldBeActive = index;
                // moduleShouldBeActive = {...moduleObj};
            }
        });

        if (completedCount === noOfModule && curActiveTab >= noOfModule - 1) {  
            try {
                const result = await this.props.getIwStatus(this.props.agencyLocation);
                if (result) {
                    toast.success("All modules are completed.");
                    return true;
                }
            } catch(error) {
                console.log(error);
                return false;
            }
        } else {
            tabShouldBeActive += 1;
            moduleShouldBeActive = {...modules[tabShouldBeActive]};
        }
        if (moduleShouldBeActive.id) {
            this.setState({
                activeTab: tabShouldBeActive, 
                activeModuleObj: moduleShouldBeActive, 
                showVideo: false
            }, () => this.getVideosList());
        }
    };

    getActiveModuleComponent = (index) => {
        const {activeModuleObj} = this.state;
        let componentList = [
            <WelcomeComponent {...this.props} moduleObj={activeModuleObj} />,
            <AgencySetupComponent {...this.props} 
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule} 
                showConfirmModal={this.showConfirmModal} 
                openPrevModule={() => this.openPrevModule(index)}
            />,
            <AddUserComponent {...this.props} 
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule} 
                showConfirmModal={this.showConfirmModal} 
                openPrevModule={() => this.openPrevModule(index)}
            />,
            <JobDescriptionComponent {...this.props} 
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule}
            />,
            // <AgencyNumberComponent {...this.props} 
            //     openPrevModule={() => this.openPrevModule(index)}
            //     moduleObj={activeModuleObj} 
            //     autocompleteModule={this.autocompleteModule} 
            //     showConfirmModal={this.showConfirmModal} 
            // />,
            <DestinationComponent {...this.props} 
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule} 
            />,
            // <HabitsComponent {...this.props} moduleObj={activeModuleObj} />,
            <KPIsComponent {...this.props} 
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule} 
            />,
            <ImportRecordComponent {...this.props} moduleObj={activeModuleObj} />,
            // <ProducerPlanComponent {...this.props} moduleObj={activeModuleObj} />,
            <CompProfileComponent {...this.props} 
                openPrevModule={() => this.openPrevModule(index)}
                moduleObj={activeModuleObj} 
                autocompleteModule={this.autocompleteModule} 
                showConfirmModal={this.showConfirmModal} 
            />,
            <FinalRollOutComponent {...this.props} moduleObj={activeModuleObj} />
        ]
        if (index >= 0 && index < componentList.length) {
            return componentList[index];
        } 
        return '';
    }

    openPrevModule = (activeTab) => {
        if (this[`moduleLi${activeTab}`]) {
            this[`moduleLi${activeTab}`].click();
        }
    }

    setActiveTab = (event, moduleIndex, activeModule) => {
        let el = event.currentTarget;

        let elements = document.querySelectorAll(".iw-progress-bar .nav-item");
        Array.prototype.forEach.call(elements, node => (
            node.className = node.className.replace(/active/g, '')
        ));

        el.className = `nav-item ${activeModule.is_completed ? 'completed' : ''} active`;
        this.setState({
            activeTab: moduleIndex, activeModuleObj: activeModule, showVideo: false
        }, () => this.getVideosList());
    };

    handleVideoPause = () => {
        
    }

    updateModuleList = async () => {
        if (this.props.agencyLocation) {
            try {
                const result = await this.props.getIWModules(this.props.agencyLocation);
                if (result) {
                    let activeModuleObj = {...this.state.activeModuleObj};
                    this.props.iwData.modules.map(module => {
                        if(module.id === activeModuleObj.id) {
                            activeModuleObj = {...module};
                        }
                    });
                    this.setState({activeModuleObj});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    }

    handleVideoEnd = async () => {
        const {selectedVideo} = this.state;
        const {videos} = this.props.iwData;
        if (!isEmpty(selectedVideo) && selectedVideo.id) {
            try {
                let updatedVideoObj = {...selectedVideo};
                if (! updatedVideoObj.seen) {
                    updatedVideoObj.seen = true;
                    
                    const result = await this.props.updateIWVideos(updatedVideoObj, videos);
                    if (result) {
                        let videoList = this.props.iwData.videos.map(video => ({...video}));
                        let selectedVideo = {...videoList[0]};
                        let unSeenCount = 0;
                        for (let index in videoList) {
                            if (!videoList[index].seen) {
                                unSeenCount += 1;
                                selectedVideo = {...videoList[index]};
                                break;
                            }
                        }
                        if (unSeenCount === 0) {
                            this.updateModuleList();
                        } else {
                            this.setState({selectedVideo});
                        }
                    }
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        } 
    }

    handleModuleCompletion = async () => {
        let activeModuleObj = {...this.state.activeModuleObj};
        activeModuleObj.is_completed = !this.state.activeModuleObj.is_completed;
        
        try {
            const result = await this.props.updateIWSetting(
                activeModuleObj, this.props.iwData.modules
            );
            if (result) {
                this.setState({activeModuleObj}, () => this.updateModuleList());
            }
        } catch (error) {
            toast.error(
                <ErrorMsg errors={error}/>, 
                {
                    autoClose: 5000,
                    className: 'toast-width'
                }
            );
        }
    }

    autocompleteModule = async () => {
        let activeModuleObj = {...this.state.activeModuleObj};
        try {
            const result = await this.props.autocompleteModule(
                activeModuleObj, this.props.iwData.modules
            );
            if (result) {
               this.setState(
                   {activeModuleObj: {...result}}, 
                   () => {
                        if(result.is_completed) {
                            this.updateModuleList();
                        }
                });
            }
        } catch (error) {}
    }

    showConfirmModal = (modelObject) => {
        const newModel = {};
        newModel.msgTitle = modelObject.hasOwnProperty('msgTitle') && modelObject.msgTitle.length > 0 ? modelObject.msgTitle : '';
        newModel.msgBody = modelObject.hasOwnProperty('msgBody') && modelObject.msgBody.length > 0 ? modelObject.msgBody : '';
        newModel.buttons = modelObject.hasOwnProperty('buttons') && modelObject.buttons.length > 0 ? modelObject.buttons : [];
        this.setState({showConfirmModal: true, model: newModel});
    };

    hideConfirmModal = (event) => {
        const name = event.target.name;
        if (name === 'discard-model-btn') {
            this.setState({showConfirmModal: false, model: {}});
        }
    };

    render() {
        const {
            activeTab, activeModuleObj, selectedVideo, showVideo, model, 
            showConfirmModal, isLoading, draggableDivPosition
        } = this.state;

        let moduleLi = this.props.iwData.modules.map((module, index) => {
            if (module.is_in_progress || module.is_completed) {
                return (
                    <li key={index} ref={li => {this[`moduleLi${index}`] = li;}}
                        className={`nav-item ${module.is_completed ? 'completed' : ''} ${activeTab === index ? 'active': ''}`} 
                        onClick={(e) => this.setActiveTab(e, index, module)}
                    >
                    <span className="white-arrow"></span>
                    <a href="javascript:" className="text-center" 
                        dangerouslySetInnerHTML={{__html: module.module_name.replace(/\*/g, '<br/>')}}></a>
                    </li>
                )
            }
        });
        let tutorialVideosDiv = [], trainingVideosDiv = [];
        this.props.iwData.videos.map((video, index) => {
            const videoLi = (
                <li key={index} className="list-group-item py-1 cursor-pointer"
                    onClick={() => this.startVideo(video)}
                >
                    <button 
                        className={`btn ${
                            video.id === selectedVideo.id ? 'btn-warning'
                            : video.seen ?  'btn-success' : 'btn-info' 
                        } btn-sm video-btn p-0 float-left`}
                    >
                        <img src={videoIcon} alt="video" height="20" width="20" />
                    </button>
                    <span className="mb-0 pl-1 cursor-pointer float-left">
                        {video.title}
                    </span>
                    <span className="mb-0 pl-1 float-right cursor-pointer">
                        {video.timing} {video.timing > 1 ? "Minutes" : "Minute"}
                    </span>
                </li>
            )
            if(video.is_tutorial_video) {
                tutorialVideosDiv.push(videoLi);
            } else {
                trainingVideosDiv.push(videoLi);
            }
        });

        return (
            <div className="main-wrapper position-relative">
                <TopNav history={this.props.history}/>
                <div className="iw-progress-bar" style={{top: "54px"}}>
                    <ul className="nav">
                        {moduleLi}
                    </ul>
                </div>
                <section className="container-fluid iw-container">
                    {!isEmpty(activeModuleObj) && activeTab === 0 &&
                        this.getActiveModuleComponent(activeTab)
                    }
                    {!isEmpty(activeModuleObj) && !isEmpty(selectedVideo) && showVideo && 
                        <Draggable defaultPosition={{x: draggableDivPosition, y: 20}}>
                            <div className="border draggableDiv">
                                <div className="dragger" title="Grab and Drag">
                                    {selectedVideo.title}
                                    <i className="font-18 fa fa-times-circle close" 
                                        onClick={this.closeVideo}></i>
                                </div>
                                <div className="player-wrapper">
                                    <ReactPlayer url={selectedVideo.video_url} 
                                        playing controls width='100%' height='100%'
                                        onEnded={this.handleVideoEnd} 
                                    />
                                </div>
                                <div className="dragger" title="Grab and Drag">
                                    :::::::
                                </div>
                            </div>
                        </Draggable>
                    }
                    {!isEmpty(activeModuleObj) && <React.Fragment>
                        <div className="row pt-3 border-bottom">
                            <div className="col-sm-8">
                                <div className="form-group form-check" >
                                    <label className="form-check-label position-relative">
                                    <input className="form-check-input my-0" type="checkbox"
                                        checked={activeModuleObj.is_completed} 
                                        value={activeModuleObj.is_completed}
                                        onChange={this.handleModuleCompletion} 
                                    />
                                        &nbsp;{activeTab === 0 ? 
                                            "Check when all videos have been seen." : 
                                            "Check when all required fields are completed."
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className="col-sm-4 text-right">
                                <a className="btn btn-info py-1 btn-sm" 
                                    href="https://calendly.com/tbaker-1" target="_blank"
                                >Book Onboarding Call</a>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-12">
                                <label>{activeModuleObj.objective}</label>
                                <br/>
                                <label>{activeModuleObj.estimation_text}</label>
                            </div>
                            {tutorialVideosDiv.length ?
                                <div className="col-sm-6">
                                    <div className="card section-border h-100 mb-0">
                                        <div className="card-header section-bg p-2 text-center text-white font-weight-bold">
                                            Tutorial Videos
                                        </div>
                                        <div className="card-title text-center pt-1 pb-2 bg-f5 mb-0">
                                            These video tutorials provide explanations for 
                                            completing data in this module. 
                                        </div>
                                        <ul className="list-group list-group-flush">
                                            {tutorialVideosDiv}
                                        </ul>
                                    </div>
                                    {isLoading &&
                                        <p className="loading-gif">
                                            <img src={loadingGIF} alt="Loading..." 
                                                width="32" height="32"/>
                                        </p>
                                    }
                                </div>
                                : null
                            }
                            {trainingVideosDiv.length ? 
                                <div className="col-sm-6">
                                    <div className="card section-border h-100 mb-0">
                                        <div className="card-header section-bg p-2 text-center text-white font-weight-bold">
                                            Optional Training Videos
                                        </div>
                                        <div className="card-title text-center pt-1 pb-2 mb-0 bg-f5">
                                            These videos provide additional training for 
                                            implementing Symphony. 
                                        </div>
                                        <ul className="list-group list-group-flush">
                                            {trainingVideosDiv}
                                        </ul>
                                    </div>
                                    {isLoading &&
                                        <p className="loading-gif">
                                            <img src={loadingGIF} alt="Loading..." 
                                                width="32" height="32"/>
                                        </p>
                                    }
                                </div>
                                : null
                            }
                        </div>
                        </React.Fragment>
                    }
                </section>
                <section>
                    {!isEmpty(activeModuleObj) && activeTab > 0 &&
                        this.getActiveModuleComponent(activeTab)
                    }
                </section>
                {!isEmpty(activeModuleObj) && activeTab === 0 &&
                    <section className="container-fluid my-3 iw-container">
                        <div className="card section-border h-100 mb-0">
                            <div className="card-title text-center pt-1 pb-2 mb-0 bg-f5">
                                To complete the Installation Wizard you will need:
                            </div>
                            <div className="card-group">
                                <div className="card">
                                    <div className="card-body border">
                                        <span className="font-weight-bold">Users</span>
                                        <ul className="list-styled-in">
                                            <li>Email address</li>
                                            <li>Hire date</li>
                                            <li>Birth Date</li>
                                            <li>Shortname</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body border">
                                        <span className="font-weight-bold">Agency Numbers</span>
                                        <ul className="list-styled-in">
                                            <li>Last year (LY) or last period revenue numbers</li>
                                            <li>Planned increase</li>
                                            <li>P&L for soft-rollout period</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body border">
                                        <span className="font-weight-bold">Job Descriptions</span>
                                        <ul className="list-styled-in">
                                            <li>Departments</li>
                                            <li>Job Titles</li>
                                            <li>Job descriptions and responsibilities</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body border">
                                        <span className="font-weight-bold">Agency Numbers</span>
                                        <ul className="list-styled-in">
                                            <li>P&L for current period</li>
                                            <li>Month-to-month previous period revenue  for Soft Rollout</li>
                                            <li>Planned retention during Soft-rollout</li>
                                            <li>Planned net growth during Soft-rollout</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border">
                                <span className="font-weight-bold">Vision</span>
                                <ul className="list-styled-in">
                                    <li>Words that describe the vision for your agency</li>
                                </ul>
                            </div>
                            <div className="card-body border">
                                <span className="font-weight-bold">
                                    Agency Management System
                                </span> (if planning to use agency management system to track performance)
                                <ul className="list-styled-in">
                                    <li>
                                        Words that describe the vision for your agency
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </section>
                }
                <section className="container-fluid iw-container">
                    {!isEmpty(activeModuleObj) && (activeModuleObj.is_completed || !activeModuleObj.is_required) ?
                        <div className="row py-2 border-top">
                            <div className="col-6">
                                <a className="btn btn-info py-1" 
                                    href="https://calendly.com/tbaker-1" target="_blank"
                                >Book Onboarding Call</a>
                            </div>
                            <div className="col-6 text-right">
                                <button className="btn btn-success py-1" 
                                    onClick={this.nextModule}>Next Module</button>
                            </div>
                            <div className="col-12 py-2"></div>
                        </div>
                        : null
                    }
                </section>
                {showConfirmModal && 
                    <ConfirmModal {...model} 
                        showConfirmModal={showConfirmModal} 
                        hide={this.hideConfirmModal}
                    />
                }
                <ZendeskSupport />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        iwData: state.IWReducer
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, InstallationWizardAction), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InstallationWizard);



// WEBPACK FOOTER //
// ./src/components/installationWizard/InstallationWizard.js